<template>
    <div class="flex-row">
      <div>
        <label :for="fieldId" class="fw-semibold">
          {{ this.commandLabel }}
          <HintComponent v-if="this.description && !showDescription" :text="this.description" />
        </label>
        <p v-if="this.description && showDescription" class="setting-help text-muted mb-2">{{ this.description }}</p>
      </div>

      <div class="d-flex align-items-center gap-2">
        <label class="switch">
          <input :id="fieldId" type="checkbox" :checked="displayValue"
                 :aria-label="commandLabel"
                 @click="setDisplayValue($event.target.checked)" @change="this.changed">
          <span class="slider round"></span>
        </label>
        <span v-if="stateText" class="state-text text-muted">{{ stateText }}</span>
      </div>
    </div>
</template>

<script>
import {SysExCommand} from "@/assets/js/SysExCommand";
import HintComponent from "@/components/HintComponent.vue";

export default {
  name: "SwitchComponent",
  components: {HintComponent},
  props: {
    commandObject: {
      type: SysExCommand,
    },
    commandLabel: {
      type: String,
    },
    description: {
      type: String,
      required: false,
    },
    showDescription: {
      type: Boolean,
      default: false
    },
    invertValue: {
      type: Boolean,
      default: false
    },
    checkedText: {
      type: String,
      default: ""
    },
    uncheckedText: {
      type: String,
      default: ""
    }
  },
  emits: ["InputChanged"],
  computed: {
    fieldId() {
      return `setting-${this.commandObject.name.replace(/[^a-z0-9_-]/gi, "-")}`
    },
    displayValue() {
      const value = Boolean(this.commandObject.value)
      return this.invertValue ? !value : value
    },
    stateText() {
      return this.displayValue ? this.checkedText : this.uncheckedText
    }
  },
  methods: {
    setDisplayValue(value) {
      this.commandObject.set_value(this.invertValue ? !value : value)
    },
    changed() {
      this.$emit('InputChanged', this.commandObject)
    }
  }
}
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

.setting-help { line-height: 1.45; }
.state-text { font-size: .95rem; }

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
